import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "o-searchList" }
const _hoisted_2 = { class: "o-searchList__filters" }
const _hoisted_3 = { class: "u-container" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "u-container" }
const _hoisted_6 = { class: "u-row" }
const _hoisted_7 = ["data-id", "data-broker-id", "onMouseover"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "o-propertyPreview o-propertyPreview--placeholder o-searchList__propertyPreview" }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "u-col-12"
}
const _hoisted_11 = { class: "o-searchList__noResults" }
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "o-buttons" }
const _hoisted_14 = ["textContent"]
const _hoisted_15 = {
  key: 0,
  class: "m-button"
}
const _hoisted_16 = ["textContent"]
const _hoisted_17 = {
  ref: "pagination",
  class: "o-searchList__intersectionTarget"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_search_select = _resolveComponent("o-search-select")!
  const _component_o_promo_box = _resolveComponent("o-promo-box")!
  const _component_o_property_preview = _resolveComponent("o-property-preview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", {
          class: _normalizeClass($data.isDesktop ? 'a-label': 'a-small'),
          textContent: _toDisplayString(_ctx.listIsLoading ? 'Henter resultater...' : $options.countText)
        }, null, 10 /* CLASS, PROPS */, _hoisted_4),
        _createVNode(_component_o_search_select, {
          icon: "order",
          options: $props.orderOptions,
          value: _ctx.order,
          onInput: _cache[0] || (_cache[0] = ($event: any) => ($options.setOrderChanged($event)))
        }, null, 8 /* PROPS */, ["options", "value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.listResults.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.listResults, (result, resultIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: resultIndex,
                class: _normalizeClass(["u-col-12", {
                            'md:u-col-6 lg:u-col-3': _ctx.view === 'list',
                            'lg:u-col-6 xxl:u-col-4': _ctx.view === 'map',
                        }])
              }, [
                (result.responseType === 'promo')
                  ? (_openBlock(), _createBlock(_component_o_promo_box, {
                      key: 0,
                      "promo-box": result.data
                    }, null, 8 /* PROPS */, ["promo-box"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      "data-id": result.data.propertyId,
                      "data-broker-id": result.data.brokerId,
                      onMouseover: ($event: any) => (
                                _ctx.setActiveProperty(result.data.propertyId)
                            ),
                      onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveProperty(null)))
                    }, [
                      _createVNode(_component_o_property_preview, {
                        "added-classes": `o-searchList__propertyPreview ${result.data.propertyId === _ctx.activeProperty ? 'isActive' : ''}`,
                        property: result.data,
                        "open-house-texts": {
                                    teaser: $props.texts.openHouseTeaser,
                                    teaserSignup: $props.texts.openHouseTeaserSignup,
                                }
                      }, null, 8 /* PROPS */, ["added-classes", "property", "open-house-texts"])
                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_7))
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (_ctx.listIsLoading || _ctx.listIsCanceled)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.listResults.length ? 2 : 8, (index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `placeholder${index}`,
                class: _normalizeClass(["u-col-12", {
                            'md:u-col-6 lg:u-col-3': _ctx.view === 'list',
                            'lg:u-col-6 xxl:u-col-4': _ctx.view === 'map',
                        }])
              }, _hoisted_9, 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (
                        !_ctx.listResults.length &&
                        !_ctx.listIsLoading &&
                        !_ctx.redirect &&
                        !_ctx.listIsCanceled
                    )
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h2", {
                  class: "a-heading2 o-searchList__noResultsTitle",
                  textContent: _toDisplayString($props.texts.noResults)
                }, null, 8 /* PROPS */, _hoisted_12),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "m-button m-button--outlined",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.zoomOutAndReset()))
                  }, [
                    _createElementVNode("span", {
                      class: "m-button__text",
                      textContent: _toDisplayString($props.texts.zoomOutAndReset)
                    }, null, 8 /* PROPS */, _hoisted_14)
                  ]),
                  ($props.texts.searchAgentButton)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_15, [
                        _createElementVNode("span", {
                          class: "m-button__text",
                          textContent: _toDisplayString($props.texts.searchAgentButton)
                        }, null, 8 /* PROPS */, _hoisted_16)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_17, null, 512 /* NEED_PATCH */)
    ])
  ]))
}